module.exports = __webpack_public_path__ + "static/media/boy-face.2118414c.svg";